export const baseUrl = "https://siram-be.vercel.app";
// export const baseUrl = "http://localhost:3001";
